import React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';

import {Helmet} from 'react-helmet';
import favicon from '../../images/et-logo.png';
import { getDirection } from '../../utils/rtl';

const Head = ({title}) => {
	const { t } = useTranslation();
	const { language } = useI18next();

	return (
		<>
			<Helmet
				defaultTitle={t("default_site_title")}
				title={title}
				htmlAttributes={{
					lang: language,
					dir: getDirection(language),
				}}
			/>
			<Helmet>
				<link rel="icon" type="image/png" href={favicon} />
				<link rel="shortcut icon" type="image/png" href={favicon} />
			</Helmet>
		</>
	)
}

export default Head;
